import React from 'react';
import { OrderResponseDto } from 'client/widget-components/ecom/types/EcomSDK';
import {
    OrderViewSection,
    OrderViewSectionTitle,
    OrderViewDataCardStack,
} from '../styles';
import DataCard, { DataRow } from '../components/DataCard';
import { MapPin, Package } from '../components/icons';
import {
    customFieldsToDataRows,
    formatBusinessAddress,
    formatPersonalAddress,
    getCustomFieldsByZone,
    withSeparatorIfNonEmpty,
} from '../utils';
import { useEcommStr } from '../useEcommStr';

interface ShippingSectionProps {
    order: OrderResponseDto;
}

const ShippingSection: React.FC<ShippingSectionProps> = ({ order }) => {
    const str = useEcommStr();
    const pickup = order.pickup;
    const fieldsByZone = getCustomFieldsByZone(order);

    const addressRows: DataRow[] = [
        {
            key: 'title',
            label: str(
                pickup
                    ? 'nativeEcommRuntime.pickup.address'
                    : 'nativeEcommRuntime.shipping.address'
            ),
        },
    ];
    if (!pickup) {
        addressRows.push({
            key: 'name',
            value: order.shipping_address?.full_name ?? undefined,
            isSecondaryValue: true,
        });
    }
    addressRows.push({
        key: 'address',
        value: pickup
            ? formatBusinessAddress(str, pickup.address)
            : formatPersonalAddress(str, order.shipping_address),
        isSecondaryValue: true,
    });
    addressRows.push(
        ...withSeparatorIfNonEmpty(
            customFieldsToDataRows(fieldsByZone.SHIPPING_ADDRESS)
        )
    );

    const methodRows: DataRow[] = [
        {
            key: 'title',
            label: pickup
                ? pickup.name
                : str('nativeEcommRuntime.shipping.method.title'),
        },
        {
            key: 'description',
            value: pickup
                ? pickup.instructions ?? undefined
                : order.shipping_method?.name,
            isSecondaryValue: true,
        },
    ];
    if (order.shipping_instructions && !pickup) {
        methodRows.push({
            key: 'shippingInstructions',
            value: order.shipping_instructions,
            isSecondaryValue: true,
        });
    }
    methodRows.push(
        ...withSeparatorIfNonEmpty(
            customFieldsToDataRows(fieldsByZone.SHIPPING_METHODS)
        )
    );

    return (
        <OrderViewSection>
            <OrderViewSectionTitle>
                {str(
                    pickup
                        ? 'nativeEcommRuntime.pickup.title'
                        : 'nativeEcommRuntime.shipping.title'
                )}
            </OrderViewSectionTitle>
            <OrderViewDataCardStack>
                <DataCard
                    rows={addressRows}
                    dataAuto='order-shipping-address'
                    icon={<MapPin />}
                />
                <DataCard
                    rows={methodRows}
                    dataAuto='order-shipping-method'
                    icon={<Package />}
                />
            </OrderViewDataCardStack>
        </OrderViewSection>
    );
};

export default ShippingSection;
